import { Flex, Text } from "@mantine/core";
import Link from "next/link";
import { memo } from "react";
import { MdOutlineThumbUp } from "react-icons/md";
import { AvatarIconMemo } from "src/component/element/AvatarIcon";
import { RankingScoreIcon } from "src/component/element/RankingItem/RankingScoreIcon";
import type { AvatarRanking } from "src/service/RankingApi/types";

import styles from "./RankingItem.module.scss";

const MyAvatarRankingItem = ({ rank, score, user }: AvatarRanking) => {
  return (
    <Link
      className={styles.rankingMyItem}
      href={`/mypage`}
      passHref
      aria-label="マイページへ遷移"
    >
      <Flex align="center">
        <div className={styles.rankingNumber}>
          <RankingScoreIcon rank={rank} />
          <p className={rank <= 3 ? styles.rankNumberWhite : styles.rankNumber}>
            {rank}
          </p>
        </div>
        <div className={styles.avatarWrap}>
          <AvatarIconMemo
            avatar={user.profileImage}
            background={user.profileBgImage}
          />
        </div>

        <div className={styles.rankingTexts}>
          <Text size={12}>{user?.nickname}</Text>
        </div>
        <Flex
          align="center"
          justify="space-between"
          className={styles.niceWrap}
          gap={4}
        >
          <MdOutlineThumbUp size={20} style={{ width: "40%" }} />
          <Text className={styles.score}>{score}</Text>
        </Flex>
      </Flex>
    </Link>
  );
};

export const MyAvatarRankingItemMemo = memo(MyAvatarRankingItem);
